import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body p-lg-20" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "mb-0" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "text-dark mb-7 fs-2" }, " Chargebacks Online - Getting Started "),
      /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mb-9" }),
      /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "h-100 d-flex flex-column pe-lg-6" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
              /*#__PURE__*/_createElementVNode("iframe", {
                class: "embed-responsive-item card-rounded h-275px w-100",
                src: "https://www.youtube.com/embed/lEX2bjFrFkk?enablejsapi=1&origin=https://www.chargebacks.online",
                allowfullscreen: "allowfullscreen",
                "data-gtm-yt-inspected-11": "true",
                id: "671018413",
                "data-gtm-yt-inspected-31871541_91": "true",
                title: "How to Implement an Ajax DataTable"
              })
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "fs-4 text-dark fw-bolder text-hover-primary text-dark lh-base"
              }, "How To Add And Setup MIDs"),
              /*#__PURE__*/_createElementVNode("span", { class: "ms-5 badge badge-light-primary fw-bold my-2" }, "VIDEO"),
              /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-5 text-gray-600 text-dark mt-4" }, " Add new mids to your chargebacks.online account quickly and easily. Import a list of merchants from an .xlsx, csv, Google or Airtable spreadsheet. Insert single or bulk merchants from your list; review and edit details before inserting, ")
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 justify-content-between d-flex flex-column" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "ps-lg-6 mb-16 mt-md-0 mt-17" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "mb-16" }, [
              /*#__PURE__*/_createElementVNode("a", {
                type: "button",
                class: "me-3 fw-bolder text-dark mb-4 fs-4 lh-base text-hover-primary",
                "data-bs-toggle": "modal",
                "data-bs-target": "#merchant_actions_tutorial_modal"
              }, "Merchant Actions"),
              /*#__PURE__*/_createElementVNode("span", { class: "ms-5 badge badge-light-primary fw-bold my-2" }, "ARTICLE"),
              /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-5 mt-4 text-gray-600 text-dark" }, " Learn about the available actions available for each MID. Importing chargebacks and transactions can be found in the merchant actions toolbar. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "mb-16" }, [
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "fw-bolder text-dark mb-4 fs-4 lh-base text-hover-primary",
                "data-bs-toggle": "modal",
                "data-bs-target": "#chargeback_actions_tutorial_modal"
              }, "Chargeback Actions"),
              /*#__PURE__*/_createElementVNode("span", { class: "ms-5 badge badge-light-primary fw-bold my-2" }, "ARTICLE"),
              /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-5 mt-4 text-gray-600 text-dark" }, " All of the chargeback functionality for the chargeback record are found in the chargeback actions toolbar. Populate transaction details, create and build responses from the incoming details page. ")
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
              /*#__PURE__*/_createElementVNode("a", {
                href: "#",
                class: "fw-bolder text-dark mb-4 fs-4 lh-base text-hover-primary",
                "data-bs-toggle": "modal",
                "data-bs-target": "#ethoca_verifi_tutorial_modal"
              }, "Ethoca / Verifi Alerts"),
              /*#__PURE__*/_createElementVNode("span", { class: "ms-5 badge badge-light-primary fw-bold my-2" }, "ARTICLE"),
              /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-5 mt-4 text-gray-600 text-dark" }, " Create Ethoca or Verifi subdomains to use for existing alert accounts. Receive webhooks directly to your customized alert callback subdomain from any existing VAR reseller ")
            ])
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "mb-17" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack mb-5" }, [
        /*#__PURE__*/_createElementVNode("h3", { class: "text-dark fs-2" }, "Video Tutorials")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mb-9" }),
      /*#__PURE__*/_createElementVNode("div", { class: "row g-10" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "card-xl-stretch ms-md-6" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "h-100 d-flex flex-column pe-lg-6" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
                /*#__PURE__*/_createElementVNode("iframe", {
                  class: "embed-responsive-item card-rounded h-200px w-100",
                  src: "https://www.youtube.com/embed/fAQj8Et6-No?enablejsapi=1&origin=https://www.chargebacks.online",
                  allow: "fullscreen",
                  "data-gtm-yt-inspected-11": "true",
                  id: "671018413",
                  "data-gtm-yt-inspected-31871541_91": "true",
                  title: "How to Implement an Ajax DataTable"
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
                /*#__PURE__*/_createElementVNode("a", {
                  href: "#",
                  class: "fs-4 text-dark fw-bolder text-hover-primary text-dark lh-base"
                }, "Adding New APIs"),
                /*#__PURE__*/_createElementVNode("span", { class: "ms-5 badge badge-light-primary fw-bold my-2" }, "VIDEO"),
                /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-5 text-gray-600 text-dark mt-4" }, " Connect your data using an easy to use interface for gateway, crm and processor API connections. Edit and manage multiple connections for a single MID. ")
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "card-xl-stretch ms-md-6" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "h-100 d-flex flex-column pe-lg-6" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
                /*#__PURE__*/_createElementVNode("iframe", {
                  class: "embed-responsive-item card-rounded h-200px w-100",
                  src: "https://www.youtube.com/embed/b7jLuW1lXEk?enablejsapi=1&origin=https://www.chargebacks.online",
                  allow: "fullscreen",
                  "data-gtm-yt-inspected-11": "true",
                  id: "671018413",
                  "data-gtm-yt-inspected-31871541_91": "true",
                  title: "How to Implement an Ajax DataTable"
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
                /*#__PURE__*/_createElementVNode("a", {
                  href: "#",
                  class: "fs-4 text-dark fw-bolder text-hover-primary text-dark lh-base"
                }, "Adding Merchant Products"),
                /*#__PURE__*/_createElementVNode("span", { class: "ms-5 badge badge-light-primary fw-bold my-2" }, "VIDEO"),
                /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-5 text-gray-600 text-dark mt-4" }, " Products are important part of the chargeback response creation process. If products and orders do not exist in the API connections they will need to be added. ")
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "card-xl-stretch ms-md-6" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "h-100 d-flex flex-column pe-lg-6" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
                /*#__PURE__*/_createElementVNode("iframe", {
                  class: "embed-responsive-item card-rounded h-200px w-100",
                  src: "https://www.youtube.com/embed/TwUS-KPqOXw?enablejsapi=1&origin=https://www.chargebacks.online",
                  allow: "fullscreen",
                  "data-gtm-yt-inspected-11": "true",
                  id: "671018413",
                  "data-gtm-yt-inspected-31871541_91": "true",
                  title: "How to Implement an Ajax DataTable"
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
                /*#__PURE__*/_createElementVNode("a", {
                  href: "#",
                  class: "fs-4 text-dark fw-bolder text-hover-primary text-dark lh-base"
                }, "Syncing Chargebacks"),
                /*#__PURE__*/_createElementVNode("span", { class: "ms-5 badge badge-light-primary fw-bold my-2" }, "VIDEO"),
                /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-5 text-gray-600 text-dark mt-4" }, " The API Sync tool will import the current month of chargebacks from your MID payment processor. Learn how to easily retrieve new chargebacks with a signle click. ")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MerchantActionsModal = _resolveComponent("MerchantActionsModal")!
  const _component_ChargebackActionsModal = _resolveComponent("ChargebackActionsModal")!
  const _component_EthocaVerifiModal = _resolveComponent("EthocaVerifiModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_MerchantActionsModal),
    _createVNode(_component_ChargebackActionsModal),
    _createVNode(_component_EthocaVerifiModal)
  ], 64))
}